import { bootstrapApplication } from '@angular/platform-browser';
import { mainConfig } from './main.config';
import { MainComponent } from './main.component';
import { register } from 'swiper/element/bundle';
import { importProvidersFrom } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { provideRouter } from '@angular/router';
import { routes } from './main.routes';
import { BrowserAnimationsModule, provideAnimations } from '@angular/platform-browser/animations';
import { provideToastr, ToastrModule } from 'ngx-toastr';
import { TokenInterceptor } from './infra/token.interceptor';

register();

bootstrapApplication(MainComponent, {
  providers: [
    importProvidersFrom(HttpClientModule),
    { provide: HTTP_INTERCEPTORS, useClass: TokenInterceptor, multi: true },
    provideAnimations(), // required animations providers
    provideToastr(), // Toastr providers
    provideRouter(routes),
  ]
}).catch(err => console.error(err));

